import { Action, Middleware } from "redux";
import { actionCreatorAuth } from "../auth/auth.reducer";
import { IApplicationState } from "./root-reducer";

const authorizationMiddleware: Middleware<{}, IApplicationState> = store => next => async (action: Action) => {
  try {
    return await next(action);
  } catch (e) {
    if ((e as Error).message === "401" || (e as Error).message === "403") {
      store.dispatch(actionCreatorAuth.unauthorized);
    } else {
      throw e;
    }
  }
};

export default authorizationMiddleware;
